import {
  TOKEN_ERROR,
  TOKEN_LOADING,
  TOKEN_SUCCESS,
  TOKEN_LOGOUT,
} from "../../ActionTypes";
import axiosInstance from "../../../../global/helpers/axiosInstance";

export const wsGetToken = (token, nextStep) => (dispatch) => {
  dispatch({
    type: TOKEN_LOADING,
  });

  axiosInstance().then((respuesta) => {
    respuesta
      .get(`token/${token}`)
      .then((res) => {
        let data = {
          ...res.data,
          origen: "tokenURL",
        };
        dispatch({
          type: TOKEN_SUCCESS,
          payload: data,
        });
        if (nextStep) {
          nextStep(true, res.data, token);
        }
      })
      .catch((err) => {
        let error = {
          detail: err.response
            ? err.response.data
            : "Error al contactar el server.",
          origen: "portal",
        };
        dispatch({
          type: TOKEN_ERROR,
          payload: error,
        });
        if (nextStep) nextStep(false, err);
      });
  });
};

export const loginTokenReset = () => (dispatch) => {
  dispatch({
    type: TOKEN_LOGOUT,
  });
};
